import { Center, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { LooseObject } from 'api/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { KPI } from '../../api/ControllingApi';
import { Card } from '../../layout/Card';

export interface KpiProps {
  data:
    | {
        submitted: KPI;
        completed: KPI;
      }
    | LooseObject;
  title: string;
}

export const KpiSubmittedVsCompleted: FC<KpiProps> = ({ data, title }) => {
  const { t } = useTranslation();

  return (
    <Card pt={4}>
      <Center>
        <Heading size={'xs'}>{title}</Heading>
      </Center>
      <SimpleGrid columns={{ sm: 2 }} spacing={4}>
        <VStack>
          <Heading size={'xss'}>{t('service_record:status.submitted.label')}</Heading>
          <Text>
            {t('forms:date.today')}: {data?.submitted?.today}
          </Text>
          <Text>
            {t('forms:date.month')}: {data?.submitted?.month}
          </Text>
          <Text>
            {t('forms:date.year')}: {data?.submitted?.year}
          </Text>
        </VStack>
        <VStack>
          <Heading size={'xss'}>{t('service_record:status.completed.label')}</Heading>
          <Text>
            {t('forms:date.today')}: {data?.completed?.today}
          </Text>
          <Text>
            {t('forms:date.month')}: {data?.completed?.month}
          </Text>
          <Text>
            {t('forms:date.year')}: {data?.completed?.year}
          </Text>
        </VStack>
      </SimpleGrid>
    </Card>
  );
};
